/**
 * Date utility functions
 */

/**
 * Parse a Firestore timestamp or date value into a JavaScript Date
 * @param {Object|Date|string|number} timestamp - Firestore timestamp, Date, ISO string, or unix timestamp
 * @returns {Date|null} - JavaScript Date or null if invalid
 */
export function parseTimestamp(timestamp) {
  if (!timestamp) return null;

  let date;
  if (timestamp._seconds) {
    date = new Date(timestamp._seconds * 1000);
  } else if (timestamp.seconds) {
    date = new Date(timestamp.seconds * 1000);
  } else if (timestamp.toDate) {
    date = timestamp.toDate();
  } else {
    date = new Date(timestamp);
  }

  return isNaN(date.getTime()) ? null : date;
}

/**
 * Calculate a human-readable "time since" string
 * @param {Object|Date|string|number} timestamp - Firestore timestamp, Date, ISO string, or unix timestamp
 * @returns {string|null} - Human readable string like "5m ago", "2h ago", "3d ago", or null if invalid
 */
export function timeSince(timestamp) {
  const date = parseTimestamp(timestamp);
  if (!date) return null;

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.round(diffMs / (1000 * 60));
  const diffHours = Math.round(diffMs / (1000 * 60 * 60));
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.round(diffDays / 7);
  const diffYears = Math.round(diffDays / 365);

  if (diffMins < 60) {
    return diffMins <= 1 ? 'just now' : `${diffMins}m ago`;
  } else if (diffHours < 24) {
    return `${diffHours}h ago`;
  } else if (diffDays < 30) {
    return `${diffDays}d ago`;
  } else if (diffDays < 365) {
    return `${diffWeeks}w ago`;
  } else {
    return `${diffYears}y ago`;
  }
}
